import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ListDefaults, TableService } from '@fry/lib/list';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { UserBookingsStore } from '@fry/booking/lib/bookings';
import { FieldType, FormField } from '@fry/lib/forms';
import { InteractiveTableOptions } from '@fry/components/common/list/interactive-table/interactive-table.component';

@Component({
    selector: 'eas-user-booking-list',
    templateUrl: './user-booking-list.component.html',
    providers: [
        TableService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserBookingListComponent implements OnInit, OnDestroy {

  public actions: EASLinkAction[] = [];

  public tableComponentOptions: InteractiveTableOptions = {
    enableColumns: true,
    enableFilters: true,
    enableExport: true,
    enableSelection: false,
    itemSingleLabel: $localize `booking`,
    itemPluralLabel: $localize `bookings`,
    tableTitle: $localize `My bookings`,
  };

  constructor(
    private store: UserBookingsStore,
    private tableService: TableService
  ) { }

  private getExportFormFields(): FormField[] {
    return [
      {
        id: 'includeUserFields',
        type: FieldType.FIELD,
        title: $localize `Include profile fields`,
        initial: true,
        widget: {
          type: 'boolean'
        }
      },
    ];
  }

  ngOnInit() {
    let listId = 'user-bookings';
    const defaults: ListDefaults = { listType: 'table', engine: 'es', pageSize: 10 };
    defaults.fixedSearchModel = {
      filter: {},
      sort: {sort_on: 'createdDate', sort_order: 'desc'},
      select: ["bookingItem", "bookingOption", "stateName", "createdDate", "modifiedDate", "view"],
      options: {
        includeFormFields: false,
        readableColumnId: '{{bookingOption}}'
      },
    };
    // defaults.hideFilters = ['bookingItem', 'bookingOptionUnique'];
    defaults.exportFormFields = this.getExportFormFields();
    defaults.featuredFilters = ['text', 'es_extra.stateName'];
    defaults.preserveState = true;
    return this.tableService
      .setupWith(this.store,
                defaults,
                listId).subscribe();
  }

  ngOnDestroy() {
  }

}
